import { http } from "../plugins/http";

//
// GET /v1/certificados saiu da cte-engine-api e passou a ser servido pela
// cte-app-web-api (o BFF do portal). Por isso usa a instancia `http`
// (VUE_APP_BASE_URL) em vez da URL da engine, que antes estava hardcoded
// nos dois callers.
//
// A engine segue dona do fluxo fiscal - emissao, cancelamento, faturas -
// e continua lendo a mesma tabela de certificados.
//
export default {

  //
  // Lista os certificados dos transportadores vinculados ao usuario que
  // vencem ate a data informada.
  //
  // vencimento: 'YYYY-MM-DD'
  //
  getCertificados: (vencimento, idUsuario) => {
    return http.get("/v1/certificados", {
      params: { vencimento, idUsuario },
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

};
